import { render, staticRenderFns } from "./Unregister.vue?vue&type=template&id=0ad612c0&scoped=true&lang=pug&"
import script from "./Unregister.vue?vue&type=script&lang=js&"
export * from "./Unregister.vue?vue&type=script&lang=js&"
import style0 from "./Unregister.scss?vue&type=style&index=0&id=0ad612c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad612c0",
  null
  
)

export default component.exports